import { Box } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "redux/model";
import { Subtitle, Title } from "ui/componentes/Layout";
import StyledAvatar from "../StyledAvatar/StyledAvatar";

const SidebarProfile = () => {
    const { profile, auth } = useSelector((state: RootState) => state.firebase);
    return (
        <Box display="flex" alignItems="center" flexDirection="column" p={2}>
            <StyledAvatar user={profile} />
            {/* <Box marginTop={1}> */}

            <Title text={`${profile.firstName} ${profile.lastName}`} />
            <Subtitle text={`${auth.email}`} />
            {/* </Box> */}
        </Box>
    );
};

export default SidebarProfile;
